import { CSSObject } from '@chakra-ui/react';

export const RunnerListItemWrapper: CSSObject = {
  color: 'gray.700',
  borderRadius: 'md',
  p: '2',
  bg: 'gray.100',
  mb: '2',
};

export const RunnerName: CSSObject = {
  fontWeight: 'semibold',
  fontSize: 'xs',
  color: 'gray.700',
  textTransform: 'capitalize',
};

export const FlexDeductionsContainer: CSSObject = {
  fontWeight: 'semibold',
  fontSize: 'xs',
  color: 'gamma.600',
  textTransform: 'uppercase',
  flexDir: 'column-reverse',
};

export const TextDeductions: CSSObject = {
  fontSize: '2xs',
  fontWeight: 'medium',
};

export const ScratchedText: CSSObject = {
  fontWeight: 'semibold',
  color: 'gamma.600',
};

export const TextScratchedInfo: CSSObject = {
  fontWeight: 'medium',
  fontSize: 'xs',
  color: 'gamma.600',
};

export const HorseHarnessRunnerSilk: CSSObject = {
  borderColor: 'gray.200',
  py: '1',
  boxSize: '8',
  maxHeight: '10',
  mr: '1.5',
};

export const RunnerPropositionWrapper: CSSObject = {
  columnGap: '1',
};

export const TextBarrierNumber: CSSObject = {
  color: 'gray.700',
};
